// extracted by mini-css-extract-plugin
module.exports = {"lazy":"styles_lazy____VP1","caption":"styles_caption__OkPJU"};